<template>
  <a-main-button
    :to="$options.consts.WINNERS_SECTION_TO"
    :font-small="fontSmall"
    :border-radius-small="borderRadiusSmall"
    class="view-winners-button__wrapper"
    v-on="$listeners"
  >
    <slot />
  </a-main-button>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import AMainButton from 'shared/AMainButton/index.vue'
import { ELEMENT_ID, ELEMENT_SELECTOR_BY_ELEMENT_ID } from 'enums/element-id'
import { ROUTE } from 'enums/routes'

export default {
  name: 'AViewWinnersButton',
  components: { AMainButton },
  props: {
    fontSmall: propValidator([PROP_TYPES.BOOLEAN], false, false),
    borderRadiusSmall: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  consts: {
    WINNERS_SECTION_TO: {
      path: ROUTE.WINNERS,
      hash: ELEMENT_SELECTOR_BY_ELEMENT_ID[ELEMENT_ID.WINNERS_SECTION]
    }
  }
}
</script>

<style lang="scss" scoped>
.view-winners-button__wrapper {
  text-decoration: none;
}
</style>
